import { Injectable } from "@angular/core";
import {ActivatedRouteSnapshot,RouterStateSnapshot, Router} from "@angular/router";
import { DataService } from "../data/data.service";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { CustomerService } from "../../services/login.service";

const url : string = 'api/Auth/login/';
const BaseUrl = environment.BaseUrl;

@Injectable({
  providedIn: "root"
})

export class NeedAuthGuardService extends DataService{
  constructor(
    private customerService: CustomerService,
    private router: Router,
    http: HttpClient
  ) 
  {
    super(url, BaseUrl, http, "Auth");
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const redirectUrl = route["_routerState"]["url"];

    if (this.customerService.isLogged()) {
      return true;
    }

    this.router.navigateByUrl("login");

    return false;
  }
}
